import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ScreenWidth extends Vue {
  public init() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth();
  }

  public getWidth(): void {
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth;
  }

  /**
   * mounted
   */
  public mounted() {
    this.init();
  }

  private screenWidth: number = 0

  get $screen() {
    return { width: this.screenWidth };
  }
}


// export default {
//   computed: {
//     $screenWidth() {
//       return vm.screenWidth
//     },
//     // 大約是直放的手機
//     $xs() {
//       return vm.screenWidth < 576
//     },
//     // 手機模式
//     $sm() {
//       return vm.screenWidth < 768 && vm.screenWidth > 577
//     },
//     // 平板直放
//     $md() {
//       return vm.screenWidth < 992
//     },
//     $lg() {
//       return vm.screenWidth > 991
//     },
//     $xl() {
//       return vm.screenWidth > 1200
//     }
//   },
//   mounted() {
//     vm.init()
//   }
// }
